import { observer } from 'mobx-react';
import * as React from 'react';
import { MulticheckStore } from '../../../../Multicheck/Store';
import ModalReactions from '../../../Modal/ModalReactions';
import ModalStore from '../../../Modal/Store';
import { LearningCollectionResource } from '../../Types';
import BulkActions from './BulkActions';
import BulkEditInvitationsStore from './BulkActions/EditInvitations/Store';
import BulkEditInvitationsReactions from './BulkActions/EditInvitations/Store/Reactions';
import EditInvitationModal from './EditInvitationModal';
import InvitationsBody from './InvitationsBody';
import InvitationsHeader from './InvitationsHeader';
import InviteParticipantsModal from './InviteParticipantModal';
import InviteParticipantReactions from './InviteParticipantModal/Reactions';
import InviteParticipantStore from './InviteParticipantModal/Store';
import InvitationsStore from './Store';
import InvitationStore from './Store/InvitationStore';
import InvitationReactions from './Store/InvitationStore/Reactions';
import InvitationsOptionsReactions from './Store/Options/Reactions';
import InvitationsReactions from './Store/Reactions';
import { InvitationResource } from './Store/Types';
import Filters from './Table/Filters';

interface Props {
  learningCollectionResource: LearningCollectionResource;
}

class InvitationsView extends React.Component<Props, {}> {
  private invitationsStore = new InvitationsStore(this.props.learningCollectionResource.payload.id);
  private invitationStore = new InvitationStore(this.invitationsStore);
  private bulkEditInvitationsStore: BulkEditInvitationsStore = new BulkEditInvitationsStore(
    this.invitationsStore,
  );
  private inviteParticipantStore = new InviteParticipantStore();
  private multicheckStore: MulticheckStore<InvitationResource> = new MulticheckStore();
  private modalStore: ModalStore = new ModalStore();

  componentDidMount(): void {
    this.invitationsStore.loading(1);
  }
  render() {
    const { learningCollectionResource } = this.props;

    return (
      <>
        <div className="bg-gray-50 mx-auto border-y-1">
          <InvitationsHeader
            learningCollectionResource={learningCollectionResource}
            open={this.inviteParticipantStore.modalStore.open}
            invitationsStore={this.invitationsStore}
          />
          <div className="bg-gray-50 max-w-clientPortalMaxWidth px-2.5 lg:px-12 pb-2.5 lg:pb-12">
            <Filters store={this.invitationsStore} />
            <InvitationsBody
              store={this.invitationsStore}
              invitationStore={this.invitationStore}
              multicheckStore={this.multicheckStore}
              modalStore={this.modalStore}
            />
          </div>
        </div>
        <InvitationsReactions store={this.invitationsStore} fireImmediately={true} />
        <InvitationReactions store={this.invitationStore} />
        <InvitationsOptionsReactions store={this.invitationsStore.optionsStore} fireImmediately />
        <BulkActions store={this.bulkEditInvitationsStore} multicheckStore={this.multicheckStore} />
        <BulkEditInvitationsReactions store={this.bulkEditInvitationsStore} />
        <InviteParticipantsModal
          learningCollectionResource={learningCollectionResource}
          inviteParticipantStore={this.inviteParticipantStore}
        />
        <EditInvitationModal store={this.invitationStore} modalStore={this.modalStore} />
        <InviteParticipantReactions
          store={this.inviteParticipantStore}
          learningCollectionResource={learningCollectionResource}
          invitationsStore={this.invitationsStore}
          fireImmediately
        />
        <ModalReactions store={this.modalStore} />
      </>
    );
  }
}

export default observer(InvitationsView);
